<template>
  <div class="imgbox">
    <img :class="img_wh" :style="imgStyle" :src="imgUrl" alt="" />
  </div>
</template>
<script>
export default {
  name: 'NetUrlPic',
  data() {
    return {
      // 图片地址
      imgUrl: '',
      // 图片类名
      img_wh: '',
      // 图片样式
      imgStyle: 'width:100%',
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.imgUrl = this.$route.query.imgUrl;
      var clientWidth = document.documentElement.clientWidth;
      var clientHeight = document.documentElement.clientHeight;
      const img_url = this.$route.query.imgUrl;

      // 创建对象
      const img = new Image();

      // 创建对象
      img.src = img_url;

      // 加载完成之后执行
      var _this = this;
      img.onload = function () {
        var res = clientWidth / clientHeight > img.width / img.height;
        var imgWidth = (img.width * clientHeight) / img.height;
        _this.imgStyle = res ? 'width:100%' : `width:${Math.ceil(imgWidth)}px;left:${-Math.ceil(imgWidth) / 2}px`;
        _this.img_wh = res ? 'img_width' : 'img_height';
      };
    });
  },
};
</script>
<style scoped>
.imgbox {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.img_width {
  position: absolute;
  bottom: 0px;
}
.img_height {
  height: 100%;
  position: absolute;
  margin-left: 50%;
}
</style>
